import React from 'react';
import { ExternalLink, Upload, Folder } from 'lucide-react';

const DropboxIntegration = ({ caseId, documentType = 'document' }) => {
  const dropboxUrl = "https://www.dropbox.com/scl/fo/zww4mv3xrjwl13oe0an5q/ANXVX-iOrN1D-yPi1Mw95pQ?rlkey=rojuak12ffeyj10wg3jf826hr&st=hbiy1e5w&dl=0";

  const handleOpenDropbox = (action) => {
    window.open(dropboxUrl, '_blank');
  };

  return (
    <div className="bg-gradient-to-r from-blue-50 to-cyan-50 border border-blue-200 rounded-lg p-6">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
          <Folder className="text-white" size={24} />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-slate-900 mb-2">Dropbox Document Storage</h3>
          <p className="text-sm text-slate-700 mb-4">
            Upload and access all your documents securely in our shared Dropbox folder.
          </p>
          
          <div className="flex gap-3">
            <button
              onClick={() => handleOpenDropbox('upload')}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium"
            >
              <Upload size={16} />
              Upload to Dropbox
            </button>
            
            <button
              onClick={() => handleOpenDropbox('view')}
              className="flex items-center gap-2 px-4 py-2 border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors text-sm font-medium"
            >
              <ExternalLink size={16} />
              View Dropbox Folder
            </button>
          </div>
          
          <div className="mt-4 pt-4 border-t border-blue-200">
            <p className="text-xs text-slate-600">
              <strong>Features:</strong> Unlimited storage • Version history • Secure sharing • Mobile access
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DropboxIntegration;
